{
  "HELP_CENTER": {
    "TITLE": "Hjelpesenter",
    "NEW_PAGE": {
      "DESCRIPTION": "Opprett selvbetjente hjelpesenterportaler for kundene dine. Hjelp dem med å finne svar raskt, uten å vente. Effektiviser henvendelser, øk agentenes produktivitet og forbedre kundestøtten.",
      "CREATE_PORTAL_BUTTON": "Opprett portal"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Uten tittel"
    },
    "HEADER": {
      "FILTER": "Filtrer etter",
      "SORT": "Sorter etter",
      "LOCALE": "Språk",
      "SETTINGS_BUTTON": "Innstillinger",
      "NEW_BUTTON": "Ny artikkel",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publisert",
        "DRAFT": "Draft",
        "ARCHIVED": "Arkivert"
      },
      "TITLES": {
        "ALL_ARTICLES": "Alle artikler",
        "MINE": "Mine artikler",
        "DRAFT": "Draft-artikler",
        "ARCHIVED": "Arkiverte artikler"
      },
      "LOCALE_SELECT": {
        "TITLE": "Velg språk",
        "PLACEHOLDER": "Velg språk",
        "NO_RESULT": "Ingen språk funnet",
        "SEARCH_PLACEHOLDER": "Søk språk"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Alle artikler",
      "PUBLISH_BUTTON": "Publiser",
      "MOVE_TO_ARCHIVE_BUTTON": "Flytt til arkiv",
      "PREVIEW": "Forhåndsvisning",
      "ADD_TRANSLATION": "Legg til oversettelse",
      "OPEN_SIDEBAR": "Åpne sidepanel",
      "CLOSE_SIDEBAR": "Lukk sidepanel",
      "SAVING": "Lagrer...",
      "SAVED": "Lagret"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Last opp bilde",
        "UPLOADING": "Laster opp...",
        "SUCCESS": "Bildet ble lastet opp",
        "ERROR": "Feil ved opplasting av bilde",
        "UN_AUTHORIZED_ERROR": "Du har ikke tilgang til å laste opp bilder",
        "ERROR_FILE_SIZE": "Bildestørrelsen må være mindre enn {size}MB",
        "ERROR_FILE_FORMAT": "Bildeformatet må være jpg, jpeg eller png",
        "ERROR_FILE_DIMENSIONS": "Bildedimensjonene må være mindre enn 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Sett inn anker",
        "TITLE": "Sett inn anker",
        "SUBMIT": "Sett inn",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Artikkelinnstillinger",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategori",
          "TITLE": "Velg kategori",
          "PLACEHOLDER": "Velg kategori",
          "NO_RESULT": "Ingen kategori funnet",
          "SEARCH_PLACEHOLDER": "Søk kategori"
        },
        "AUTHOR": {
          "LABEL": "Forfatter",
          "TITLE": "Velg forfatter",
          "PLACEHOLDER": "Velg forfatter",
          "NO_RESULT": "Ingen forfattere funnet",
          "SEARCH_PLACEHOLDER": "Søk forfatter"
        },
        "META_TITLE": {
          "LABEL": "Metatittel",
          "PLACEHOLDER": "Legg til en metatittel"
        },
        "META_DESCRIPTION": {
          "LABEL": "Metabeskrivelse",
          "PLACEHOLDER": "Legg til metabeskrivelse for bedre SEO-resultater..."
        },
        "META_TAGS": {
          "LABEL": "Meta-nøkkelord",
          "PLACEHOLDER": "Legg til meta-nøkkelord adskilt med komma..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arkiver artikkel",
        "DELETE": "Slett artikkel"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Ukategorisert",
      "SEARCH_RESULTS": "Søkeresultater for {query}",
      "EMPTY_TEXT": "Søk etter artikler å sette inn i svar.",
      "SEARCH_LOADER": "Søker...",
      "INSERT_ARTICLE": "Sett inn",
      "NO_RESULT": "Ingen artikler funnet",
      "COPY_LINK": "Kopier artikkellenke til utklippstavlen",
      "OPEN_LINK": "Åpne artikkel i ny fane",
      "PREVIEW_LINK": "Forhåndsvis artikkel"
    },
    "PORTAL": {
      "HEADER": "Portaler",
      "DEFAULT": "Standard",
      "NEW_BUTTON": "Ny portal",
      "ACTIVE_BADGE": "aktiv",
      "CHOOSE_LOCALE_LABEL": "Velg et språk",
      "LOADING_MESSAGE": "Laster portaler...",
      "ARTICLES_LABEL": "artikler",
      "NO_PORTALS_MESSAGE": "Det finnes ingen tilgjengelige portaler",
      "ADD_NEW_LOCALE": "Legg til et nytt språk",
      "POPOVER": {
        "TITLE": "Portaler",
        "PORTAL_SETTINGS": "Portalinnstillinger",
        "SUBTITLE": "Du har flere portaler og kan ha forskjellige språk for hver portal.",
        "CANCEL_BUTTON_LABEL": "Avbryt",
        "CHOOSE_LOCALE_BUTTON": "Velg språk"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "artikler",
            "ADD": "Legg til språk",
            "VISIT": "Besøk nettsted",
            "SETTINGS": "Innstillinger",
            "DELETE": "Slett"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Portalkonfigurasjoner",
            "ITEMS": {
              "NAME": "Navn",
              "DOMAIN": "Egendefinert domene",
              "SLUG": "Slug",
              "TITLE": "Portaltittel",
              "THEME": "Temafarge",
              "SUB_TEXT": "Portal undertekst"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Tilgjengelige språk",
            "TABLE": {
              "NAME": "Språknavn",
              "CODE": "Språkkode",
              "ARTICLE_COUNT": "Ant. artikler",
              "CATEGORIES": "Ant. kategorier",
              "SWAP": "Bytt",
              "DELETE": "Slett",
              "DEFAULT_LOCALE": "Standard"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Slett portal",
          "MESSAGE": "Er du sikker på at du vil slette denne portalen",
          "YES": "Ja, slett portal",
          "NO": "Nei, behold portal",
          "API": {
            "DELETE_SUCCESS": "Portalen ble slettet",
            "DELETE_ERROR": "Feil ved sletting av portal"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Rediger portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Grunnleggende informasjon"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Portaltilpasning"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategorier"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Språk"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategorier i",
          "NEW_CATEGORY": "Ny kategori",
          "TABLE": {
            "NAME": "Navn",
            "DESCRIPTION": "Beskrivelse",
            "LOCALE": "Språk",
            "ARTICLE_COUNT": "Ant. artikler",
            "ACTION_BUTTON": {
              "EDIT": "Rediger kategori",
              "DELETE": "Slett kategori"
            },
            "EMPTY_TEXT": "Ingen kategorier funnet"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Oppdater grunnleggende innstillinger"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Hjelpesenterinformasjon",
            "BODY": "Grunnleggende informasjon om portalen"
          },
          "CUSTOMIZATION": {
            "TITLE": "Hjelpesentertilpasning",
            "BODY": "Tilpass portal"
          },
          "FINISH": {
            "TITLE": "Voilà! 🎉",
            "BODY": "Du er klar!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Tilbake",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Opprett portal",
            "TITLE": "Hjelpesenterinformasjon",
            "CREATE_BASIC_SETTING_BUTTON": "Opprett grunnleggende portalinnstillinger"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Portaltilpasning",
            "TITLE": "Hjelpesentertilpasning",
            "UPDATE_PORTAL_BUTTON": "Oppdater portalinnstillinger"
          },
          "FINISH_PAGE": {
            "TITLE": "Voilà! 🎉 Du er klar!",
            "MESSAGE": "Du kan nå se den opprettede portalen på siden for alle portaler.",
            "FINISH": "Gå til alle portaler"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Last opp logo",
          "HELP_TEXT": "Denne logoen vises i portalens topptekst.",
          "IMAGE_UPLOAD_SUCCESS": "Logoen ble lastet opp",
          "IMAGE_UPLOAD_ERROR": "Logoen ble slettet",
          "IMAGE_DELETE_ERROR": "Feil ved sletting av logo"
        },
        "NAME": {
          "LABEL": "Navn",
          "PLACEHOLDER": "Portalnavn",
          "HELP_TEXT": "Navnet vil bli brukt internt i den offentlige portalen.",
          "ERROR": "Navn er påkrevd"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal-slug for URL-er",
          "ERROR": "Slug er påkrevd"
        },
        "DOMAIN": {
          "LABEL": "Egendefinert domene",
          "PLACEHOLDER": "Egendefinert domene for portal",
          "HELP_TEXT": "Legg til bare hvis du vil bruke et egendefinert domene for portalene dine. F.eks.: {exampleURL}",
          "ERROR": "Skriv inn en gyldig domene-URL"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Lenke til hjemmeside",
          "PLACEHOLDER": "Lenke til portalens hjemmeside",
          "HELP_TEXT": "Lenken som brukes for å gå tilbake fra portalen til hjemmesiden. F.eks.: {exampleURL}",
          "ERROR": "Skriv inn en gyldig URL for hjemmesiden"
        },
        "THEME_COLOR": {
          "LABEL": "Temafarge for portal",
          "HELP_TEXT": "Denne fargen vises som temafarge for portalen."
        },
        "PAGE_TITLE": {
          "LABEL": "Sidetittel",
          "PLACEHOLDER": "Portalens sidetittel",
          "HELP_TEXT": "Sidetittelen vil bli brukt i den offentlige portalen.",
          "ERROR": "Sidetittel er påkrevd"
        },
        "HEADER_TEXT": {
          "LABEL": "Topptekst",
          "PLACEHOLDER": "Portalens topptekst",
          "HELP_TEXT": "Portalens topptekst vil bli brukt i den offentlige portalen.",
          "ERROR": "Portalens topptekst er påkrevd"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portalen ble opprettet.",
          "ERROR_MESSAGE_FOR_BASIC": "Kunne ikke opprette portalen. Prøv igjen.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portalen ble oppdatert.",
          "ERROR_MESSAGE_FOR_UPDATE": "Kunne ikke oppdatere portalen. Prøv igjen."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Legg til et nytt språk",
        "SUB_TITLE": "Dette legger til et nytt språk i listen over tilgjengelige oversettelser.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Språk",
          "PLACEHOLDER": "Velg et språk",
          "ERROR": "Språk er påkrevd"
        },
        "BUTTONS": {
          "CREATE": "Opprett språk",
          "CANCEL": "Avbryt"
        },
        "API": {
          "SUCCESS_MESSAGE": "Språket ble lagt til",
          "ERROR_MESSAGE": "Kunne ikke legge til språk. Prøv igjen."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Standardspråket ble oppdatert",
          "ERROR_MESSAGE": "Kunne ikke oppdatere standardspråket. Prøv igjen."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Språket ble fjernet fra portalen",
          "ERROR_MESSAGE": "Kunne ikke fjerne språket fra portalen. Prøv igjen."
        }
      }
    },
    "TABLE": {
      "404": "Ingen artikler samsvarer med søket ditt 🔍",
      "LOADING_MESSAGE": "Laster artikler...",
      "NO_ARTICLES": "Det finnes ingen tilgjengelige artikler",
      "HEADERS": {
        "TITLE": "Tittel",
        "CATEGORY": "Kategori",
        "READ_COUNT": "Visninger",
        "STATUS": "Status",
        "LAST_EDITED": "Sist redigert"
      },
      "COLUMNS": {
        "BY": "av",
        "AUTHOR_NOT_AVAILABLE": "Forfatter er ikke tilgjengelig"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Laster artikkel...",
      "TITLE_PLACEHOLDER": "Artikkeltittel skrives her",
      "CONTENT_PLACEHOLDER": "Skriv artikkelen din her",
      "API": {
        "ERROR": "Feil ved lagring av artikkel"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Feil ved publisering av artikkel",
        "SUCCESS": "Artikkelen ble publisert"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Feil ved arkivering av artikkel",
        "SUCCESS": "Artikkelen ble arkivert"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Feil ved endring av artikkel til draft",
        "SUCCESS": "Artikkelen ble satt til draft"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Bekreft sletting",
          "MESSAGE": "Er du sikker på at du vil slette artikkelen?",
          "YES": "Ja, slett",
          "NO": "Nei, behold den"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Artikkelen ble slettet",
        "ERROR_MESSAGE": "Feil ved sletting av artikkel"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Legg til artikkeloverskrift og innhold, først da kan du oppdatere innstillingene"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Søk etter artikler"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Opprett en kategori",
        "SUB_TITLE": "Kategorien vil bli brukt i den offentlige portalen for å kategorisere artikler.",
        "PORTAL": "Portal",
        "LOCALE": "Språk",
        "NAME": {
          "LABEL": "Navn",
          "PLACEHOLDER": "Kategorinavn",
          "HELP_TEXT": "Kategorinavnet og ikonet vil bli brukt i den offentlige portalen for å kategorisere artikler.",
          "ERROR": "Navn er påkrevd"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Kategori-slug for URL-er",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug er påkrevd"
        },
        "DESCRIPTION": {
          "LABEL": "Beskrivelse",
          "PLACEHOLDER": "Gi en kort beskrivelse av kategorien.",
          "ERROR": "Beskrivelse er påkrevd"
        },
        "BUTTONS": {
          "CREATE": "Opprett kategori",
          "CANCEL": "Avbryt"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorien ble opprettet",
          "ERROR_MESSAGE": "Kunne ikke opprette kategori"
        }
      },
      "EDIT": {
        "TITLE": "Rediger en kategori",
        "SUB_TITLE": "Redigering av en kategori vil oppdatere kategorien i den offentlige portalen.",
        "PORTAL": "Portal",
        "LOCALE": "Språk",
        "NAME": {
          "LABEL": "Navn",
          "PLACEHOLDER": "Kategorinavn",
          "HELP_TEXT": "Kategorinavnet og ikonet vil bli brukt i den offentlige portalen for å kategorisere artikler.",
          "ERROR": "Navn er påkrevd"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Kategori-slug for URL-er",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug er påkrevd"
        },
        "DESCRIPTION": {
          "LABEL": "Beskrivelse",
          "PLACEHOLDER": "Gi en kort beskrivelse av kategorien.",
          "ERROR": "Beskrivelse er påkrevd"
        },
        "BUTTONS": {
          "CREATE": "Oppdater kategori",
          "CANCEL": "Avbryt"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorien ble oppdatert",
          "ERROR_MESSAGE": "Kunne ikke oppdatere kategori"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategorien ble slettet",
          "ERROR_MESSAGE": "Kunne ikke slette kategori"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Søk artikler",
      "PLACEHOLDER": "Søk artikler",
      "NO_RESULT": "Ingen artikler funnet",
      "SEARCHING": "Søker...",
      "SEARCH_BUTTON": "Søk",
      "INSERT_ARTICLE": "Sett inn lenke",
      "IFRAME_ERROR": "URL-en er tom eller ugyldig. Kan ikke vise innhold.",
      "OPEN_ARTICLE_SEARCH": "Sett inn artikkel fra Hjelpesenter",
      "SUCCESS_ARTICLE_INSERTED": "Artikkelen ble satt inn",
      "PREVIEW_LINK": "Forhåndsvis artikkel",
      "CANCEL": "Lukk",
      "BACK": "Tilbake",
      "BACK_RESULTS": "Tilbake til resultater"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Hjelpesenter",
      "DESCRIPTION": "Opprett brukervennlige selvbetjeningsportaler. Hjelp brukerne dine med å få tilgang til artiklene og motta støtte 24/7. Oppgrader abonnementet ditt for å aktivere denne funksjonen.",
      "SELF_HOSTED_DESCRIPTION": "Opprett brukervennlige selvbetjeningsportaler. Hjelp brukerne dine med å få tilgang til artiklene og motta støtte 24/7. Kontakt administratoren din for å aktivere denne funksjonen.",
      "BUTTON": {
        "LEARN_MORE": "Lær mer",
        "UPGRADE": "Oppgrader"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Flere portaler",
          "DESCRIPTION": "Opprett flere hjelpesenterportaler for ulike produkter med samme konto."
        },
        "LOCALES": {
          "TITLE": "Full støtte for språk",
          "DESCRIPTION": "Lokaliser portalen på ditt eget språk. Vi støtter alle språk og tillater oversettelser for hver artikkel."
        },
        "SEO": {
          "TITLE": "SEO-vennlig design",
          "DESCRIPTION": "Tilpass metataggene dine for å forbedre synligheten i søkemotorer med våre SEO-vennlige sider."
        },
        "API": {
          "TITLE": "Full API-støtte",
          "DESCRIPTION": "Bruk portalen som en headless CMS med tredjeparts front-end-rammeverk ved hjelp av våre API-er."
        }
      }
    },
    "LOADING": "Laster...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} visning | {count} visninger",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publiser",
            "DRAFT": "Draft",
            "ARCHIVE": "Arkiver",
            "DELETE": "Slett"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Publisert",
            "ARCHIVED": "Arkivert"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Ukategorisert"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Alle artikler",
          "MINE": "Mine",
          "DRAFT": "Draft",
          "PUBLISHED": "Publisert",
          "ARCHIVED": "Arkivert"
        },
        "CATEGORY": {
          "ALL": "Alle kategorier"
        },
        "LOCALE": {
          "ALL": "Alle språk"
        },
        "NEW_ARTICLE": "Ny artikkel"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Skriv en artikkel",
          "SUBTITLE": "Skriv en innholdsrik artikkel, la oss komme i gang!",
          "BUTTON_LABEL": "Ny artikkel"
        },
        "MINE": {
          "TITLE": "Du har ikke skrevet noen artikler her",
          "SUBTITLE": "Alle artikler skrevet av deg vises her for rask tilgang."
        },
        "DRAFT": {
          "TITLE": "Det finnes ingen artikler i draft",
          "SUBTITLE": "Draft-artikler vil vises her"
        },
        "PUBLISHED": {
          "TITLE": "Det finnes ingen publiserte artikler",
          "SUBTITLE": "Publiserte artikler vil vises her"
        },
        "ARCHIVED": {
          "TITLE": "Det finnes ingen artikler i arkivet",
          "SUBTITLE": "Arkiverte artikler vises ikke på portalen, du kan bruke det til å merke utdaterte eller foreldede sider"
        },
        "CATEGORY": {
          "TITLE": "Det finnes ingen artikler i denne kategorien",
          "SUBTITLE": "Artikler i denne kategorien vil vises her"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Ny kategori",
        "EDIT_CATEGORY": "Rediger kategori",
        "CATEGORIES_COUNT": "{n} kategori | {n} kategorier",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategorier ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} artikler) | {categoryName} ({categoryCount} artikkel)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Ingen kategorier funnet",
        "SUBTITLE": "Kategorier vil vises her. Du kan legge til en kategori ved å klikke på knappen «Ny kategori»."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} artikkel | {count} artikler",
        "EXPAND": "Vis underkategorier",
        "COLLAPSE": "Skjul underkategorier",
        "MENU": {
          "NEW_ARTICLE": "Ny artikkel",
          "ADD_SUBCATEGORY": "Legg til underkategori",
          "EDIT": "Rediger",
          "DELETE": "Slett"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorien ble opprettet",
            "ERROR_MESSAGE": "Kunne ikke opprette kategori"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorien ble oppdatert",
            "ERROR_MESSAGE": "Kunne ikke oppdatere kategori"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorien ble slettet",
            "ERROR_MESSAGE": "Kunne ikke slette kategori"
          },
          "CONFIRM": {
            "TITLE": "Slett kategori",
            "DESCRIPTION": "Er du sikker på at du vil slette denne kategorien? Artiklene i den vil bli ukategoriserte.",
            "DESCRIPTION_WITH_CHILDREN": "Er du sikker på at du vil slette denne kategorien? Artiklene i den vil bli ukategoriserte, og {count} underkategori vil bli flyttet til toppnivået. | Er du sikker på at du vil slette denne kategorien? Artiklene i den vil bli ukategoriserte, og {count} underkategorier vil bli flyttet til toppnivået.",
            "CONFIRM": "Slett"
          }
        },
        "HEADER": {
          "CREATE": "Opprett kategori",
          "EDIT": "Rediger kategori",
          "DESCRIPTION": "Redigering av en kategori vil oppdatere kategorien i den offentlige portalen.",
          "PORTAL": "Portal",
          "LOCALE": "Språk"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Navn",
            "PLACEHOLDER": "Kategorinavn",
            "ERROR": "Navn er påkrevd"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Kategori-slug for URL-er",
            "ERROR": "Slug er påkrevd",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Beskrivelse",
            "PLACEHOLDER": "Gi en kort beskrivelse av kategorien.",
            "ERROR": "Beskrivelse er påkrevd"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Overordnet kategori",
            "PLACEHOLDER": "Velg en overordnet kategori",
            "NONE": "Ingen (toppnivå)"
          }
        },
        "BUTTONS": {
          "CREATE": "Opprett",
          "EDIT": "Oppdater",
          "CANCEL": "Avbryt"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Ingen språk tilgjengelig | {n} språk | {n} språk",
      "NEW_LOCALE_BUTTON_TEXT": "Nytt språk",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} artikkel | {count} artikler",
        "CATEGORIES_COUNT": "{count} kategori | {count} kategorier",
        "DEFAULT": "Standard",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Gjør til standard",
          "DELETE": "Slett"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Legg til et nytt språk",
        "DESCRIPTION": "Velg språket denne artikkelen skal skrives på. Dette blir lagt til i listen over oversettelser, og du kan legge til flere senere.",
        "COMBOBOX": {
          "PLACEHOLDER": "Velg språk..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Språket ble lagt til",
          "ERROR_MESSAGE": "Kunne ikke legge til språk. Prøv igjen."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Lagrer...",
          "SAVED": "Lagret"
        },
        "PREVIEW": "Forhåndsvisning",
        "PUBLISH": "Publiser",
        "DRAFT": "Draft",
        "ARCHIVE": "Arkiver",
        "BACK_TO_ARTICLES": "Tilbake til artikler"
      },
      "DRAFT": {
        "PENDING_LABEL": "Upubliserte endringer",
        "PROMOTE": "Publiser endringer",
        "DISCARD": "Forkast endringer",
        "PROMOTE_SUCCESS": "Draft-endringer publisert til den aktive artikkelen",
        "PROMOTE_ERROR": "Kunne ikke publisere draft-endringene",
        "DISCARD_SUCCESS": "Draft-endringer forkastet",
        "DISCARD_ERROR": "Kunne ikke forkaste draft-endringene"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Versjonshistorikk",
        "TITLE": "Versjonshistorikk",
        "BACK": "Tilbake til artikkelen",
        "LOADING": "Laster versjoner...",
        "EMPTY": "Ingen versjoner ennå. Endringer i denne artikkelen vises her.",
        "EMPTY_CONTENT": "Denne versjonen har ikke noe innhold.",
        "CURRENT_BADGE": "Gjeldende",
        "RESTORED_BADGE": "Gjenopprettet",
        "AUTOMATED_USER": "Automatisk oppdatering",
        "RESTORE": "Gjenopprett denne versjonen",
        "RESTORE_DIALOG": {
          "TITLE": "Gjenopprette denne versjonen?",
          "DESCRIPTION": "Artikkelen går tilbake til teksten i denne versjonen. Ingenting går tapt — den nåværende teksten blir liggende i historikken, og en publisert artikkel viser fortsatt den aktive versjonen helt til du publiserer endringen.",
          "CONFIRM": "Gjenopprett"
        },
        "RESTORE_SUCCESS": "Versjonen ble gjenopprettet",
        "RESTORE_ERROR": "Kunne ikke gjenopprette denne versjonen",
        "FETCH_ERROR": "Kunne ikke laste inn versjonshistorikken"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Flere egenskaper",
        "TRANSLATE": "Oversett",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Ukategorisert",
        "EDITOR_PLACEHOLDER": "Skriv noe...",
        "HTML_EMBED": {
          "TITLE": "Sett inn egendefinert HTML",
          "DESCRIPTION": "Lim inn rå HTML som en iframe, en innbygging eller et widget-utdrag. Den vises som den er i den publiserte artikkelen.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Sett inn"
        },
        "PRIMARY_CATEGORY": "Hovedkategori"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Artikkelegenskaper",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Metabeskrivelse",
        "META_DESCRIPTION_PLACEHOLDER": "Legg til metabeskrivelse",
        "META_TITLE": "Metatittel",
        "META_TITLE_PLACEHOLDER": "Legg til metatittel",
        "META_TAGS": "Meta-nøkkelord",
        "META_TAGS_PLACEHOLDER": "Legg til meta-nøkkelord",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Språkvarianter",
        "LANGUAGE_MUTATIONS_EMPTY": "Ingen koblede artikler ennå",
        "ADD_MUTATION": "Legg til",
        "REMOVE_MUTATION": "Fjern"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Koble språkvarianter",
        "SEARCH_PLACEHOLDER": "Søk artikler etter tittel",
        "EMPTY": "Ingen samsvarende artikler",
        "CANCEL": "Avbryt",
        "ADD_SELECTED": "Legg til valgte",
        "SUCCESS": "Varianter oppdatert",
        "ERROR": "Kunne ikke oppdatere varianter"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Oversett artikkel",
        "DESCRIPTION": "Velg språkene du vil oversette denne artikkelen til. Språk som allerede er oversatt, vil bli oversatt på nytt til en draft for gjennomgang.",
        "EMPTY": "Ingen andre språk er tilgjengelige",
        "CONNECTED_BADGE": "Oversatt",
        "CANCEL": "Avbryt",
        "TRANSLATE": "Oversett",
        "SUCCESS": "Oversettelsen starter snart. De oversatte artiklene vises som språkvarianter snart.",
        "ERROR": "Kunne ikke starte oversettelsen"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Feil ved lagring av artikkel"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Ny portal",
      "PORTALS": "Portaler",
      "CREATE_PORTAL": "Opprett og administrer flere portaler",
      "ARTICLES": "artikler",
      "DOMAIN": "domene",
      "PORTAL_NAME": "Portalnavn"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Opprett ny portal",
      "DESCRIPTION": "Gi portalen din et navn og opprett en brukervennlig URL-slug. Du kan endre begge deler senere i innstillingene.",
      "CONFIRM_BUTTON_LABEL": "Opprett",
      "NAME": {
        "LABEL": "Navn",
        "PLACEHOLDER": "Brukerveiledning",
        "MESSAGE": "Velg et navn for portalen din.",
        "ERROR": "Navn er påkrevd"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug er påkrevd",
        "FORMAT_ERROR": "Bruk bare bokstaver, tall og bindestreker, for eksempel: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Kunne ikke laste opp bildet! Prøv igjen",
          "IMAGE_UPLOAD_SUCCESS": "Bildet ble lagt til. Klikk på lagre endringer for å lagre logoen",
          "IMAGE_DELETE_SUCCESS": "Logoen ble slettet",
          "IMAGE_DELETE_ERROR": "Kunne ikke slette logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "Bildestørrelsen må være mindre enn {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Navn",
          "PLACEHOLDER": "Portalnavn",
          "ERROR": "Navn er påkrevd"
        },
        "HEADER_TEXT": {
          "LABEL": "Topptekst",
          "PLACEHOLDER": "Portalens topptekst"
        },
        "PAGE_TITLE": {
          "LABEL": "Sidetittel",
          "PLACEHOLDER": "Portalens sidetittel"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Lenke til hjemmeside",
          "PLACEHOLDER": "Lenke til portalens hjemmeside",
          "ERROR": "Ugyldig URL. Lenken til hjemmesiden må starte med 'http://' eller 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal-slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Live chat-widget",
          "PLACEHOLDER": "Velg live chat-widget",
          "HELP_TEXT": "Velg en live chat-widget som skal vises på hjelpesenteret ditt"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Offentlig tilgjengelig",
          "HELP_TEXT": "Gjør portalen tilgjengelig for alle med lenken.",
          "OPTIONS": {
            "PUBLIC": "Ja",
            "PRIVATE": "Nei"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Lenkemål",
          "HELP_TEXT": "Velg om lenker i artikler åpnes i gjeldende vindu eller i et nytt.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Gjeldende vindu",
            "NEW_WINDOW": "Nytt vindu"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Standard bildestørrelse",
          "HELP_TEXT": "Størrelse som brukes på hvert bilde du setter inn i en artikkel. Velg Original for å sette inn bilder i deres egen størrelse, og velg i stedet en størrelse per bilde."
        },
        "BRAND_COLOR": {
          "LABEL": "Merkevarefarge"
        },
        "CUSTOM_HTML": {
          "LABEL": "Egendefinert HTML",
          "PLACEHOLDER": "<!-- Lim inn analyse- eller sporingskoden din her -->",
          "HELP_TEXT": "Settes inn ved starten av <body>-taggen på hver hjelpesenterside. Bruk den til Google Analytics, Google Tag Manager eller andre sporingskodebiter. Koden vises nøyaktig slik den ble angitt, og blir ikke validert."
        },
        "SAVE_CHANGES": "Lagre endringer"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Egendefinert domene",
          "LABEL": "Egendefinert domene:",
          "DESCRIPTION": "Du kan hoste portalen din på et egendefinert domene. Hvis nettstedet ditt for eksempel er yourdomain.com og du vil at portalen skal være tilgjengelig på docs.yourdomain.com, skriver du bare det inn i dette feltet.",
          "PLACEHOLDER": "Egendefinert domene for portal",
          "EDIT_BUTTON": "Rediger egendefinert domene",
          "ADD_BUTTON": "Legg til egendefinert domene",
          "DIALOG": {
            "ADD_HEADER": "Legg til egendefinert domene",
            "EDIT_HEADER": "Rediger egendefinert domene",
            "ADD_CONFIRM_BUTTON_LABEL": "Legg til domene",
            "EDIT_CONFIRM_BUTTON_LABEL": "Oppdater domene",
            "LABEL": "Egendefinert domene",
            "PLACEHOLDER": "Egendefinert domene for portal",
            "ERROR": "Egendefinert domene er påkrevd"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS-konfigurasjon",
            "DESCRIPTION": "Logg inn på kontoen din hos DNS-leverandøren, og legg til CNAME-posten nedenfor for underdomenet ditt.",
            "HELP_TEXT": "Når dette er gjort, kan du kontakte support for å be om det automatisk genererte SSL-sertifikatet.",
            "CONFIRM_BUTTON_LABEL": "Forstått!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Slett {portalName}",
          "HEADER": "Slett portal",
          "DESCRIPTION": "Slett denne portalen permanent. Denne handlingen kan ikke angres",
          "DIALOG": {
            "HEADER": "Er du sikker på at du vil slette {portalName}?",
            "DESCRIPTION": "Dette er en permanent handling som ikke kan angres.",
            "CONFIRM_BUTTON_LABEL": "Slett"
          }
        },
        "EDIT_CONFIGURATION": "Rediger konfigurasjon"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portalen ble opprettet",
          "ERROR_MESSAGE": "Kunne ikke opprette portal"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portalen ble oppdatert",
          "ERROR_MESSAGE": "Kunne ikke oppdatere portal"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Vedlegg",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Legg til fil",
      "DROP_HERE": "Dra og slipp filer her",
      "COPY_LINK": "Kopier lenke",
      "LINK_COPIED": "Lenken ble kopiert til utklippstavlen",
      "COPY_FAILED": "Kunne ikke kopiere lenke",
      "DELETE": "Slett",
      "CANCEL": "Avbryt",
      "QUEUED": "I kø",
      "UPLOADING": "Laster opp",
      "UPLOAD_FAILED": "Kunne ikke laste opp fil",
      "FILE_TOO_LARGE": "Filen overskrider grensen på 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Oversettelsesordbok",
        "DESCRIPTION": "Begreper som defineres her, legges til i AI-oversettelsesprompten slik at de alltid oversettes på samme måte. Nøkkelbegrepet er skrevet på {locale}."
      },
      "NEW_TERM": "Nytt begrep",
      "EMPTY_STATE": {
        "TITLE": "Ingen begreper i ordboken ennå",
        "SUBTITLE": "Legg til et begrep og oversettelsen for hvert språk. Når en artikkel oversettes, håndheves disse begrepene slik at produktterminologien din forblir konsistent."
      },
      "LIST": {
        "TERM": "Begrep",
        "TRANSLATIONS": "Oversettelser",
        "ACTIONS": "Handlinger"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Legg til begrep",
          "EDIT": "Rediger begrep",
          "DESCRIPTION": "Begrepet nedenfor håndheves under AI-oversettelse av artiklene i hjelpesenteret ditt.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Hovedspråk"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Begrep ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Begrep er påkrevd"
          },
          "DESCRIPTION": {
            "LABEL": "Kontekst/notater (valgfritt)",
            "PLACEHOLDER": "Når og hvordan dette begrepet brukes, for å hjelpe oversetteren med å unngå tvetydighet."
          },
          "TRANSLATIONS": "Oversettelser",
          "TRANSLATION_PLACEHOLDER": "La stå tomt for å la AI-en oversette fritt",
          "AUTO_TRANSLATE": {
            "BUTTON": "Oversett alle automatisk",
            "CONFIRM": "Oversette til {count} språk med AI?",
            "CONFIRM_BUTTON": "Oversett",
            "CANCEL": "Avbryt",
            "SUCCESS": "Oversettelser generert – se gjennom og lagre",
            "ERROR": "Kunne ikke oversette automatisk, prøv igjen"
          }
        },
        "BUTTONS": {
          "CREATE": "Legg til begrep",
          "EDIT": "Lagre",
          "CANCEL": "Avbryt"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Begrepet ble lagt til",
            "ERROR_MESSAGE": "Kunne ikke legge til begrepet, prøv igjen"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Begrepet ble oppdatert",
            "ERROR_MESSAGE": "Kunne ikke oppdatere begrepet, prøv igjen"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Slett begrep",
          "DESCRIPTION": "Er du sikker på at du vil slette dette begrepet? Det vil ikke lenger bli håndhevet under oversettelse.",
          "CONFIRM": "Slett"
        },
        "API": {
          "SUCCESS_MESSAGE": "Begrepet ble slettet",
          "ERROR_MESSAGE": "Kunne ikke slette begrepet, prøv igjen"
        }
      }
    }
  }
}
